import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import { useExportDisbursementBatchMutation } from '../../../../api-services/payments/paymentsApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { type BatchIdActionProps } from './DisbursementBatchPage'

const ExportDisbursementBatch: React.FC<BatchIdActionProps> = ({ disbursementBatch }: BatchIdActionProps) => {
  const dispatch = useAppDispatch()

  const [apiExportDisbursementBatchTrigger, apiExportBatchResult] = useExportDisbursementBatchMutation()
  const handleExportBatch = async (): Promise<void> => {
    await apiExportDisbursementBatchTrigger(disbursementBatch.disbursementBatchId)
  }

  useEffect(() => {
    if (apiExportBatchResult.isSuccess) {
      dispatch(setNotification({ open: true, severity: 'success', message: `Disbursement batch ${apiExportBatchResult.data.disbursementBatchId} exported.` }))
    }

    if (apiExportBatchResult.isError) {
      dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(apiExportBatchResult.error) }))
    }
  }, [apiExportBatchResult.isSuccess, apiExportBatchResult.isError])

  return (
    <>
      <Button type={'button'} variant={'contained'} disabled={!disbursementBatch.exportable} onClick={handleExportBatch}>
        Export Batch
      </Button>
    </>
  )
}

export default ExportDisbursementBatch
